import React, { useState } from "react";
import styles from "./form.module.css";
import { Row, Col, Button, Form, Container } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";

const FormSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData("");
    console.log("Form Data Submitted: ", formData);
  };
  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col>
            <div className={styles.main_section}>
              <Heading>
                Let’s level up your business <br /> together
              </Heading>
              <Paragraph>
                You can reach us anytime via{" "}
                <span style={{ color: "#FF5C00", textDecoration: "underline" }}>Info@crossborderbtc</span>
              </Paragraph>
            </div>

            {/* ---------form----------- */}
            <Form className={styles.formContainer} onSubmit={handleSubmit}>
              <Row className={styles.row_sec}>
                <Col md={6}>
                  <Form.Group controlId="formName">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter Your Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formEmail">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      inputMode="email"
                      placeholder="Enter Your Email Address"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className={styles.row_sec}>
                <Col md={6}>
                  <Form.Group controlId="formPhone">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone"
                      inputMode="numeric"
                      placeholder="Enter Your Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formSubject">
                    <Form.Label>Subject</Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      placeholder="Enter Subject"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className={styles.row_sec}>
                <Col>
                  <Form.Group controlId="formMessage">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      placeholder="Type Something"
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <Button type="submit" className={styles.submitBtn}>
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
            
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default FormSection;
